<template lang="">
  <div class="mobile-main">
    <my-menu></my-menu>
    <div class='main-page'>
      <header>
        <img src="https://static.lespark.cn/pc_img/images/logo.png" alt="">
      </header>
      <div :class="['main-page-swiper',{
        safari:isSafari
      }]">
        <div class='mobile-slogan'>
          <h1 class='mobile-video' :class="{'ensize':isEn}">{{h1Content}}</h1>
          <p class='mobile-love'>{{h2Content}}</p>
        </div>

        <div class='mobile-swiper'>
          <img src="https://static.lespark.cn/pc_img/images/mobile_shell.png" alt="">
          <van-swipe class="my-swipe" :autoplay="3000" :show-indicators='false' @change='changeSwiper'>
            <van-swipe-item>
              <img class='mobile-img' :src="baiHuaImg" alt="">
            </van-swipe-item>
            <van-swipe-item>
              <img v-if="!isEn" class='mobile-img' src="https://static.lespark.cn/pc_img/images/mobile1.png" alt="">
               <img v-else class='mobile-img' src="https://static.lespark.cn/pc_img/images/baihua/live.png"
                   alt="">
            </van-swipe-item>
            <van-swipe-item>
              <img v-if="!isEn" class='mobile-img' src="https://static.lespark.cn/pc_img/images/mobile2.png" alt="">
              <img v-else class='mobile-img' src="https://static.lespark.cn/pc_img/images/baihua/video_v2.png"
                     alt="">
            </van-swipe-item>
            <van-swipe-item>
              <img v-if="!isEn" class='mobile-img' src="https://static.lespark.cn/pc_img/images/mobile3.png" alt="">
              <img v-else class='mobile-img' src="https://static.lespark.cn/pc_img/images/baihua/nearby.png"
                     alt="">
            </van-swipe-item>
            <van-swipe-item>
              <img v-if="!isEn" class='mobile-img' src="https://static.lespark.cn/pc_img/images/mobile4.png" alt="">
               <img v-else class='mobile-img' src="https://static.lespark.cn/pc_img/images/baihua/couple.png"
                     alt="">
            </van-swipe-item>
            <van-swipe-item>
              <img v-if="!isEn" class='mobile-img' src="https://static.lespark.cn/pc_img/images/mobile5.png" alt="">
              <img v-else class='mobile-img' src="https://static.lespark.cn/pc_img/images/baihua/voiceChat.png"
                     alt="">
            </van-swipe-item>
            <van-swipe-item>
              <img v-if="!isEn" class='mobile-img' src="https://static.lespark.cn/pc_img/images/mobile6.png" alt="">
               <img v-else class='mobile-img' src="https://static.lespark.cn/pc_img/images/baihua/match_v2.png"
                     alt="">
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class='download-box'>
          <span class='download-btn' @click='downloadApp'>{{ $t("mobleTxt.download") }}</span>
          <span class='recharge' @click='rechargeApp'>{{ $t("header.nav2") }}</span>
        </div>
        <van-icon size='8vw' name="arrow-down" color="#434343" />
      </div>
    </div>
    <div class="up-swipe-items">
      <p class='header-title'>{{ $t("home.liveTitle3") }}</p>
      <div class='mobile-content'>
        <div class='topic-items' v-for="(item,index) in attentionList.slice(0,4)">
          <img :src="item.image_url + '_200x200'" alt="">
          <div>
            <p class='topic-title'> <a :href="'/topic/'+ item.tag">#{{item.tag}}#</a> </p>
            <p class='topic-people'>{{item.total_feeds}}{{ $t("topicAll.join") }}</p>
            <p class='topic-desc'>{{item.desc}}</p>
          </div>
        </div>
      </div>
      <p class='mobile-more'><a href="/topic-all.html">{{ $t("mobleTxt.more") }}</a> </p>
    </div>
    <div class='up-swipe-items'>
      <p class='header-title'>{{ $t("header.nav1") }}</p>
      <div class='mobile-content-live'>
        <ul class='mobile-content-ul'>
          <li class='live-items' v-for="(item,index) in hotOnlineList.slice(0,6)">
            <a :href="'/live/'+ item.lgid+'.html'">
              <img :src="getImg(item.live_pic,item.avatar )" alt="">
              <div class='live-content'>
                <span>{{item.nickname}}</span>
                <span>
                  <van-icon name="user-o" />{{item.view_num}}
                </span>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <p class='mobile-more'><a href="/live-all.html">{{ $t("mobleTxt.more") }}</a> </p>
    </div>

    <mobilefoot></mobilefoot>

    <div id='mask' v-if="isMask" @click="isMask=false">
      <img src="http://static.lespark.cn/activity/img/mark.png" alt="">
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import { Button, Swipe, SwipeItem, Popup, Icon, Toast } from 'vant';
  import ajax from "Common/ajax";
  import constans from "Constans";
  import myMenu from 'Views/components/menu'
  import mobilefoot from 'Views/components/mobilefoot'
  import Util from 'Common/util';
  Vue.use(Button);
  Vue.use(Swipe);
  Vue.use(SwipeItem);
  Vue.use(Popup);
  Vue.use(Icon);
  Vue.use(Toast);
  const userUrl = constans.AllUrl.url.dev;
  const goLinkUrl = constans.UrlLink.goLink.menu;
  const goLinkeKey = constans.UrlLink.getUrlKey();
  export default {
    name: 'mobile',
    components: { 'myMenu': myMenu, mobilefoot },
    data() {
      return {
        mobileTitle: '实时直播',
        mobileDescribe: '你的声音 甜过初恋',
        attentionList: [],
        hotOnlineList: [],
        noattention: false,
        isSafari: false,
        isMask:false,
        h1Content: '',
        h2Content: '',
        baiHuaImg:'',
        isEn:false,
      }
    },

    created() {
      this.fetchData()
      this.fetchLive()
      this.isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
      var langWindow = Util.getLang()
      if (langWindow=='en'){
        this.isEn = true
        this.baiHuaImg = 'https://static.lespark.cn/pc_img/images/baihua/baihua-swiper-en.png'
      }else if(langWindow=='zh-f'){
        this.baiHuaImg = 'https://static.lespark.cn/pc_img/images/baihua/baihua-swiper-tw.png'
      }else{
        this.baiHuaImg = 'https://static.lespark.cn/pc_img/images/baihua/baihua-swiper-cn.png'
      }
    },
    mounted() {
      this.h1Content = this.$t('swiper')[0].h1Content
      this.h2Content = this.$t('swiper')[0].h2Content
    },
    computed: {
      getImg() {
        return function (live_pic, avatar) {
          const img = live_pic || avatar
          return img + '_200x200'
        }
      }
    },
    methods: {
      goTopic(value) {
        window.location.href = '/topic/' + value
      },
      goLive(id) {
        window.location.href = '/live/' + id + '.html'
      },
      rechargeApp() {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          // window.location.href = 'http://wx.lespark.cn/wx/buy_diamonds'
          window.location.href = goLinkUrl['wx_buy_diamonds'][goLinkeKey]
        } else {
          // window.location.href = 'http://api3.lespark.cn/pay_web_order'
          window.location.href = goLinkUrl['rechargeApp'][goLinkeKey]
        }
      },
      goAllTopic() {
        window.location.href = '/topic-all.html'
      },
      goAllLive() {
        window.location.href = '/live-all.html'
      },
      //获取直播数据
      fetchLive() {
        ajax.Get({
          url: userUrl + "/pc_user_online_lives?t=" + new Date().getTime(),
          headers: {
            bundle_id: 'pc',
            'bundle-id': 'pc',
            lang: 'zh-hans'
          }
        }).then(ref => {
          let data = ref.data;
          this.hotOnlineList = data.online_list;
        }).catch(ref => {
        })
      },
      //获取话题数据
      fetchData() {
        ajax
          .Get({
            url:
              userUrl +
              "/v2/get_hot_tags?_t=" +
              new Date().getTime(),
            headers: {
              bundle_id: "pc",
              'bundle-id': 'pc',
              lang: "zh-hans",
              token: "",
              user_id: ''
            }
          })
          .then(ref => {
            let data = ref.data;
            this.attentionList = data.tags || [];
            if (this.attentionList.length == 0) {
              this.noattention = false;
            } else {
              this.noattention = true;
            }
            console.log(this.attentionList)
          })
          .catch(ref => {
            console.log(ref);
          });

      },
      // 下载app
      downloadApp() {
        const uL = navigator.language;
        var weixin = navigator.userAgent.indexOf('MicroMessenger') > -1 //是否为微信浏览器
        if(weixin){
          this.isMask = true
          return
        }
        let is_oversea;
        if(window.location.host.includes('lespark.us')){
          is_oversea = true
        }else{
          is_oversea = false
        }
        if(is_oversea){
          window.location.href = "https://lespark.onelink.me/sRtA/2saczuub"
        }else{
          if (uL == "zh-CN") {
            window.location.href = "https://go.onelink.me/iAGK/lovepark"
          } else {
            window.location.href = "https://go.onelink.me/KJsf/lovepark "
          }
        }
      },
      changeSwiper(index) {
        this.h1Content = this.$t('swiper')[index].h1Content
        this.h2Content = this.$t('swiper')[index].h2Content
       // if(index == 0){
       //   this.mobileTitle = '百花计划'
       //   this.mobileDescribe = '拍短视频，享千万补贴'
       // }else if (index == 1) {
       //    this.mobileTitle = '实时直播'
       //    this.mobileDescribe = '你的声音 甜过初恋'
       //  } else if (index == 2) {
       //    this.mobileTitle = '多人视频'
       //    this.mobileDescribe = '红娘在线 姻缘一线牵'
       //  } else if (index == 3) {
       //    this.mobileTitle = '附近的人'
       //    this.mobileDescribe = '发现你身边的同好圈'
       //  } else if (index == 4) {
       //    this.mobileTitle = '情侣公园'
       //    this.mobileDescribe = '记录相爱点滴'
       //  } else if (index == 5) {
       //    this.mobileTitle = '即时语聊'
       //    this.mobileDescribe = '你的声音 甜过初恋'
       //  } else if (index == 6) {
       //    this.mobileTitle = '快速配对'
       //    this.mobileDescribe = '交友脱单 心动匹配'
       //  }
      }
    }
  }
</script>
<style lang="" scoped>
  body,
  html {
    height: 100%;
  }

  .mobile-main {
    position: relative;
    width: 100vw;
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .download-box {
    display: flex;
    width: 100vw;
    height: 12vw;
    justify-content: center;
    align-items: center;
  }

  .mobile-more {
    width: 22.2667vw;
    height: 5.8667vw;
    line-height: 5.8667vw;
    background: #F9F9F9;
    border-radius: 1.0667vw;
    margin: 0 auto 2.6667vw;
    text-align: center;
    font-size: 3.2vw;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #777777;
    letter-spacing: 1px;
  }

  .mobile-more>a {
    color: #777777;
  }

  .main-page {
    height: 100vh;
    background: url('https://static.lespark.cn/pc_img/images/mobile/mobile-bg.jpg') no-repeat;
    background-size: cover;
  }

  .header-title {
    height: 12.4vw;
    line-height: 12.4vw;
    text-align: center;
    font-size: 5.0667vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }

  header {
    box-sizing: border-box;
    width: 100%;
    padding: 0 5.3333vw;
    height: 10vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  header>img {
    width: 19.0667vw;
    height: 6.2667vw;
  }

  .mobile-content {

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  .main-page-swiper {
    height: calc(100vh - 10vw);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  .safari {
    height: calc(100vh - 10vw - 100px);
  }

  .mobile-content-live {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  .mobile-content-ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .van-swipe-item {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .up-swipe-items {
    display: flex;
    flex-direction: column;
  }

  .mobile-img {
    width: 100%;
    height: 100%;
    border-radius: 5.6vw;
  }

  .recharge {
    width: 40vw;
    height: 11.7333vw;
    border-radius: 6.8vw;
    border: 0.2667vw solid #FF5B7A;
    box-sizing: border-box;
    font-size: 4.8vw;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #FF3C5E;
    line-height: 11.7333vw;
    letter-spacing: 0.1333vw;
    text-align: center;
  }

  .download-btn {
    width: 40vw;
    height: 11.7333vw;
    background: linear-gradient(51deg, #FF3B56 0%, #FF4949 100%);
    border-radius: 6.8vw;
    font-size: 4.8vw;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 11.7333vw;
    text-align: center;
    letter-spacing: 0.1333vw;
    margin-right: 6.6667vw;
  }

  .up-swipe {
    width: 100%;
    height: 100%;
  }

  .mobile-swiper {
    width: 50.9333vw;
    height: 104.2667vw;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5.6vw;
  }

  .mobile-swiper>img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
  }

  .my-swipe {
    width: 100%;
    height: 100%;
  }

  .mobile-video {
    font-size: 10.6667vw;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #FFFFFF;
    letter-spacing: 0.2667vw;
    text-shadow: 0.2667vw 0.2667vw 4.8vw rgba(244, 37, 102, 0.74);
  }

  .mobile-love {
    font-size: 4vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    margin-top: 2vw;
    text-shadow: 0.1333vw 0.1333vw 0.9333vw rgba(255, 120, 163, 0.57);
  }


  .topic-items {
    width: 92vw;
    height: 28vw;
    background: #F9F9F9;
    border-radius: 1.0667vw;
    display: flex;
    align-items: center;
    margin-bottom: 2.6667vw;
  }

  .topic-items>img {
    width: 28vw;
    height: 28vw;
    object-fit: cover;
    border-radius: 1.0667vw;
    margin-right: 5.3333vw;
  }

  .topic-title {
    font-size: 4vw;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    letter-spacing: 0.1333vw;
  }

  .topic-title>a {
    color: #333333;
  }

  .topic-people {
    font-size: 3.2vw;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    letter-spacing: 0.1333vw;
    margin: 2.6667vw 0 5.3333vw;
  }

  .topic-desc {
    width: 55.4667vw;
    height: 5vw;
    font-size: 3.7333vw;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #555555;
    letter-spacing: 0.1333vw;
    overflow: hidden;
  }

  .live-items {
    width: 44.6667vw;
    height: 56.4vw;
    margin-right: 2.6667vw;
    margin-bottom: 2.6667vw;
  }

  .live-items img {
    width: 100%;
    height: 44.6667vw;
    border-radius: 1.0667vw 1.0667vw 0vw 0vw;
    object-fit: cover;
  }

  .live-content {
    height: 11.7333vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 3.7333vw;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    letter-spacing: 0.1333vw;
  }

  .live-content>span:first-child {
    width: 20.9333vw;
    white-space: nowrap;
    overflow: hidden;
  }

  #mask {
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: rgba(0, 0, 0, 1);
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0
  }

  #mask>img {
    width: 85%;
    position: absolute;
    top: 0;
    right: 0
  }

  .ensize{
    text-align: center;
    font-size: 8.668vw;
  }
</style>



// WEBPACK FOOTER //
// src/views/pages/home/content/mobile.vue